import {
  channelsForContactPointKind,
  defaultEnabledChannelsForKind,
  effectiveChannelPermissionsForContactPoint,
  enabledChannelSelectionChanged,
  enabledChannelsForContactPoint,
  normalizeEnabledChannelsForKind,
} from "../../../../../../../../../../../../../_shared/_logic/contact-channels"

export {
  channelsForContactPointKind,
  defaultEnabledChannelsForKind,
  effectiveChannelPermissionsForContactPoint,
  enabledChannelSelectionChanged,
  enabledChannelsForContactPoint,
  normalizeEnabledChannelsForKind,
}

export type ContactChannelOption = {
  name: string
  value: ContactChannel
}

export type ContactChannelTag = {
  channel: ContactChannel
  label: string
  color: string
  tooltip: string
}

const CHANNEL_LABELS: Record<ContactChannel, string> = {
  EMAIL: "E-Mail",
  SMS: "SMS",
  WHATSAPP: "WhatsApp",
  MOBILE_MESSAGE: "Mobile Nachricht",
  PHONE: "Anruf",
  LETTER: "Brief",
  WEB_BOT: "Terminbot",
  VOICE_BOT: "Telefonbot",
}

const CHANNEL_COLORS: Partial<Record<ContactChannel, string>> = {
  EMAIL: "neutral",
  SMS: "neutral",
  WHATSAPP: "neutral",
  MOBILE_MESSAGE: "neutral",
  PHONE: "neutral",
  LETTER: "neutral",
}

const normalizeText = (value: unknown) => `${value ?? ""}`.trim()

export const contactChannelLabel = (channel: ContactChannel) => CHANNEL_LABELS[channel] ?? channel

export const contactChannelOptionsForKind = (
  kind: ContactPointKind | string | null | undefined,
): ContactChannelOption[] =>
  channelsForContactPointKind(kind).map((channel) => ({
    name: contactChannelLabel(channel),
    value: channel,
  }))

export const disabledChannelReasonLabel = (permission: ContactPointChannelPermission) => {
  const reason = normalizeText(permission.disabled_reason).toLowerCase()
  const source = normalizeText(permission.source).toUpperCase()

  if (reason === "customer_opt_out" || source === "PORTAL") return "durch Terminportal abbestellt"

  if (reason === "admin_disabled" || source === "MANUAL") return "in KehrBlatt deaktiviert"

  return "deaktiviert"
}

export const disabledChannelsTooltip = (contact: ContactPoint) => {
  const disabled = effectiveChannelPermissionsForContactPoint(contact).filter(
    (permission) => !permission.is_enabled,
  )

  if (!disabled.length) return ""

  return disabled
    .map(
      (permission) =>
        `${contactChannelLabel(permission.channel)} deaktiviert: ${disabledChannelReasonLabel(permission)}`,
    )
    .join("\n")
}

export const contactChannelTagsForContactPoint = (contact: ContactPoint): ContactChannelTag[] => {
  return effectiveChannelPermissionsForContactPoint(contact)
    .filter((permission) => permission.is_enabled)
    .map((permission) => {
      const label = contactChannelLabel(permission.channel)

      return {
        channel: permission.channel,
        label,
        color: CHANNEL_COLORS[permission.channel] ?? "neutral",
        tooltip: "",
      }
    })
}

export const noActiveChannelsTooltip = (contact: ContactPoint) =>
  disabledChannelsTooltip(contact) || "Für diesen Kontaktpunkt ist aktuell kein Kontaktkanal aktiv."
